import React from 'react'

import { Typography } from '@material-ui/core'
import { Check } from '@material-ui/icons'

import { ItemWrap } from './ProductDescriptionItem.style'

const ProductDescriptionItem = ({ children, icon, ...rest }) => {
  return (
    <ItemWrap {...rest}>
      {icon || <Check color='primary' />}
      <Typography style={{ marginLeft: 12, fontWeight: 500 }}>{children}</Typography>
    </ItemWrap>
  )
}

export default ProductDescriptionItem
